import { render, staticRenderFns } from "./DeleteableDocumentList.vue?vue&type=template&id=749ae67b"
import script from "./DeleteableDocumentList.vue?vue&type=script&lang=js"
export * from "./DeleteableDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports